import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { commonActions } from "stores/common/commonActions";
import { FaqAction } from "stores/FaqTableStore/FaqAction";

const mapStateToProps = (state) => {
  return {
    FaqTableList: state.Faq.FaqTableList,
    isloadingFaqTable: state.Faq.FaqisLoading,
    CategoriesList: state.Faq.CategoriesList,
    FaqKeywordList: state.Faq.FaqKeywordList,
    FaqKeywordIsLoading: state.Faq.FaqKeyword.isLoading,
    ParentCategoriesList: state.Faq.ParentCategoriesList,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getFaqTableAction: FaqAction.getFaqAction,
      getCategoriesList: FaqAction.getFaqCategories,
      getFaqKeywordAction: FaqAction.getFaqKeywordAction,
      postFaqKeywordAction: FaqAction.postFaqKeywordAction,
      updateFaqKeywordAction: FaqAction.updateFaqKeywordAction,
      deleteFaqKeyword: FaqAction.deleteFaqKeyword,
      getFaqParentCategories: FaqAction.getFaqParentCategories,
      deleteFaq: FaqAction.deleteFaq,
      updateFaq:FaqAction.updateFaq,
      snackbarAction:commonActions.setSnackbarAction
      

    },
    dispatch
  );

const FaqQuestionsStore = (Container) =>
  connect(mapStateToProps, mapDispatchToProps)(Container);
export default FaqQuestionsStore;
